import { combineReducers } from 'redux-immutable';
import { fromJS } from 'immutable';

const MODULE_NAME = 'modules/unify-status-site';
const createActionType = (actionName) => `${MODULE_NAME}/${actionName}`;

export const SET_SEARCH_RESULTS = createActionType('SET_SEARCH_RESULTS');
export const SET_USER_SESSION = createActionType('SET_USER_SESSION');
export const SET_PCN = createActionType('SET_PCN');
export const HAS_CONSENTED = createActionType('HAS_CONSENTED');
export const SET_ACTIVE_ELETTER = createActionType('SET_ACTIVE_ELETTER');
export const SET_PENDING_ELETTER = createActionType('SET_PENDING_ELETTER');
export const SET_ESIGN_DISAGREEMENT_BANNER = createActionType('SET_ESIGN_DISAGREEMENT_BANNER');
export const SET_CONSENT_SAVED_BANNER = createActionType('SET_CONSENT_SAVED_BANNER');
export const SET_SESSION_EXPIRED_BANNER = createActionType('SET_SESSION_EXPIRED_BANNER');
export const SET_NO_RESULTS = createActionType('SET_NO_RESULTS');
export const SET_APPLICANT_NAME = createActionType('SET_APPLICANT_NAME');
export const RESET_STATE = createActionType('RESET_STATE');

const generalInitialState = fromJS({
  searchResults: null,
  userSession: null,
  pcn: null,
  hasConsented: null,
  activeELetter: null,
  pendingELetter: null,
  showESignDisagreementBanner: false,
  showConsentSavedBanner: false,
  showSessionExpiredBanner: false,
  noResults: false,
  applicantName: null,
});

export const generalReducer = (state, action) => {
  const currentState =
    typeof state === 'undefined' ? generalInitialState : state;

  switch (action.type) {
    case SET_SEARCH_RESULTS:
      return currentState.set('searchResults', action.payload);
    case SET_USER_SESSION:
      return currentState.set('userSession', action.payload);
    case SET_PCN:
      return currentState.set('pcn', action.payload);
    case HAS_CONSENTED:
      return currentState.set('hasConsented', action.payload);
    case SET_ACTIVE_ELETTER:
      return currentState.set('activeELetter', action.payload);
    case SET_PENDING_ELETTER:
      return currentState.set('pendingELetter', action.payload);
    case SET_ESIGN_DISAGREEMENT_BANNER:
      return currentState.set('showESignDisagreementBanner', action.payload);
    case SET_CONSENT_SAVED_BANNER:
      return currentState.set('showConsentSavedBanner', action.payload);
    case SET_SESSION_EXPIRED_BANNER:
      return currentState.set('showSessionExpiredBanner', action.payload);
    case SET_NO_RESULTS:
      return currentState.set('noResults', action.payload);
    case SET_APPLICANT_NAME:
      return currentState.set('applicantName', action.payload);
    default:
      return currentState;
  }
};

export const setSearchResults = (payload) => ({
  type: SET_SEARCH_RESULTS,
  payload,
});

export const setUserSession = (payload) => ({
  type: SET_USER_SESSION,
  payload,
});

export const setPcn = (payload) => ({
  type: SET_PCN,
  payload,
});

export const setHasConsented = (payload) => ({
  type: HAS_CONSENTED,
  payload,
});

export const setActiveELetter = (payload) => ({
  type: SET_ACTIVE_ELETTER,
  payload,
});

export const setPendingELetter = (payload) => ({
  type: SET_PENDING_ELETTER,
  payload,
});

export const setESignDisagreementBanner = (payload) => ({
  type: SET_ESIGN_DISAGREEMENT_BANNER,
  payload,
});

export const setConsentSavedBanner = (payload) => ({
  type: SET_CONSENT_SAVED_BANNER,
  payload,
});

export const setSessionExpiredBanner = (payload) => ({
  type: SET_SESSION_EXPIRED_BANNER,
  payload,
});

export const setNoResults = (payload) => ({
  type: SET_NO_RESULTS,
  payload,
});

export const setApplicantName = (payload) => ({
  type: SET_APPLICANT_NAME,
  payload,
});

export const resetState = () => ({ type: RESET_STATE });

const appReducer = combineReducers({
  general: generalReducer,
});

const rootReducer = (state, action) => {
  const stateToReduce = action.type === RESET_STATE ? undefined : state;
  return appReducer(stateToReduce, action);
};

export const selectGeneralState = (state) =>
  state.get('general', generalInitialState);

export const selectSearchResults = (state) =>
  selectGeneralState(state).get('searchResults');

export const selectUserSession = (state) =>
  selectGeneralState(state).get('userSession');

export const selectPcn = (state) =>
  selectGeneralState(state).get('pcn');

export const selectHasConsented = (state) =>
  selectGeneralState(state).get('hasConsented');

export const selectActiveELetter = (state) =>
  selectGeneralState(state).get('activeELetter');

export const selectPendingELetter = (state) =>
  selectGeneralState(state).get('pendingELetter');

export const selectESignDisagreementBanner = (state) =>
  selectGeneralState(state).get('showESignDisagreementBanner');

export const selectConsentSavedBanner = (state) =>
  selectGeneralState(state).get('showConsentSavedBanner');

export const selectSessionExpiredBanner = (state) =>
  selectGeneralState(state).get('showSessionExpiredBanner');

export default rootReducer;
